import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

const FormInput = ({ blok, handleInputChange, formValue }) => {
  const { label, type, name, required, placeholder } = blok;

  const blockWidths = {
    '25%': 'col-span-12 md:col-span-3',
    '33%': 'col-span-12 md:col-span-6 lg:col-span-4',
    '50%': 'w-full col-span-12 md:col-span-6',
    '66%': 'w-full col-span-12 md:col-span-6 lg:col-span-8',
    '75%': 'w-full col-span-12 md:col-span-9',
    '100%': 'w-full col-span-12',
  };

  const width = blok.width ? blockWidths[blok.width] : 'w-full col-span-12';

  return (
    <div className={`mb-2 ${width} px-4 md:px-8`} {...storyblokEditable(blok)}>
      <label>
        <span className="text-sm font-normal">
          {label} {label && required ? '*' : ''}
        </span>
        <input
          type={type}
          name={name}
          value={formValue}
          className="form-input m-0 block w-full rounded-lg border border-solid border-dusty-gray bg-yellow-25 bg-clip-padding px-3 py-1.5 text-sm font-normal text-black transition ease-in-out focus:border-dusty-gray focus:text-black focus:outline-none focus:bg-white"
          placeholder={placeholder}
          required={required}
          onChange={handleInputChange}
        />
      </label>
    </div>
  );
};

export default FormInput;
